import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock, Teleport as _Teleport } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "popup popup--small is-filter-popup is-opened",
  "data-popup-id": "filter"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "icon icon-close" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = { class: "popup__title" }
const _hoisted_5 = { class: "popup__content" }
const _hoisted_6 = { class: "filter-form" }
const _hoisted_7 = { class: "popup__btns is-compact" }
const _hoisted_8 = ["disabled"]
const _hoisted_9 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FilterType = _resolveComponent("FilterType")!
  const _component_FilterCategory = _resolveComponent("FilterCategory")!
  const _component_FilterSource = _resolveComponent("FilterSource")!
  const _component_FilterRegion = _resolveComponent("FilterRegion")!
  const _component_FilterCompany = _resolveComponent("FilterCompany")!
  const _component_FilterPrice = _resolveComponent("FilterPrice")!
  const _component_FilterStartDate = _resolveComponent("FilterStartDate")!
  const _component_FilterEndDate = _resolveComponent("FilterEndDate")!

  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    (_ctx.showMobileFiltersModal)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleMobileFiltersModal && _ctx.toggleMobileFiltersModal(...args))),
          class: "popup-overlay"
        }))
      : _createCommentVNode("", true),
    (_ctx.showMobileFiltersModal)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("a", {
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toggleMobileFiltersModal && _ctx.toggleMobileFiltersModal(...args))),
            class: "popup__close",
            style: {"cursor":"pointer"}
          }, _hoisted_3),
          _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('mobile.filters')), 1),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("form", _hoisted_6, [
              _createVNode(_component_FilterType),
              _createVNode(_component_FilterCategory),
              _createVNode(_component_FilterSource),
              _createVNode(_component_FilterRegion),
              (_ctx.$route.name !== 'company')
                ? (_openBlock(), _createBlock(_component_FilterCompany, { key: 0 }))
                : _createCommentVNode("", true),
              _createVNode(_component_FilterPrice),
              _createVNode(_component_FilterStartDate),
              _createVNode(_component_FilterEndDate)
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("a", {
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.reset && _ctx.reset(...args))),
              class: "btn btn-white",
              disabled: _ctx.resetIsDisabled ? 'disabled' : null,
              style: {"cursor":"pointer"}
            }, _toDisplayString(_ctx.$t('search.reset_btn')), 9, _hoisted_8),
            _createElementVNode("a", {
              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.apply && _ctx.apply(...args))),
              class: "btn btn-blue",
              disabled: _ctx.applyIsDisabled ? 'disabled' : null,
              style: {"cursor":"pointer"}
            }, _toDisplayString(_ctx.$t('search.apply_btn')), 9, _hoisted_9)
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}